/**
 * Trackbar PDP: Swiper, PhotoSwipe, theme.Variants, quantity, sticky ATC
 */
(function () {
  function centsFromVariant(variant) {
    if (!variant || variant.price == null) return 0;
    var n = Number(variant.price);
    return Number.isFinite(n) ? n : 0;
  }

  function centsCompare(variant) {
    if (!variant || variant.compare_at_price == null) return null;
    var n = Number(variant.compare_at_price);
    return Number.isFinite(n) ? n : null;
  }

  function formatMoneyCents(cents) {
    if (!Number.isFinite(cents)) return "";
    var formatted = "";
    if (typeof theme !== "undefined" && theme.Currency && theme.settings) {
      formatted = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } else {
      formatted = (cents / 100).toFixed(2);
    }
    return formatted.replace(/(\.00|,00)$/, "");
  }

  function getStrings(root) {
    var comingSoonLabel =
      (root && root.dataset.comingSoonLabel) || "Coming soon";
    return {
      soldOut:
        typeof theme !== "undefined" && theme.strings
          ? theme.strings.soldOut
          : "Sold out",
      comingSoon: comingSoonLabel,
      unavailable:
        typeof theme !== "undefined" && theme.strings
          ? theme.strings.unavailable
          : "Unavailable",
    };
  }

  function isComingSoon(root) {
    return root && root.getAttribute("data-coming-soon") === "true";
  }

  function unavailableLabel(root, str) {
    return isComingSoon(root) ? str.comingSoon : str.soldOut;
  }

  function goToMediaSlide(root, swiperInstance, variant) {
    if (!swiperInstance || !variant) return;
    var ref = variant.featured_image || variant.featured_media;
    if (!ref) return;
    var mediaId = ref.id != null ? String(ref.id) : null;
    if (!mediaId) return;
    var slides = root.querySelectorAll(
      ".main-product-trackbar__swiper .swiper-slide[data-media-id]",
    );
    slides.forEach(function (slide, index) {
      if (slide.getAttribute("data-media-id") === mediaId) {
        swiperInstance.slideTo(index, 0);
      }
    });
  }

  function updateCompareUi(root, variant) {
    var wrap = root.querySelector("[data-trackbar-compare-wrap]");
    var inner = root.querySelector("[data-trackbar-compare-inner]");
    var stickyWrap = root.querySelector("[data-trackbar-sticky-compare-wrap]");
    var stickyInner = root.querySelector(
      "[data-trackbar-sticky-compare-inner]",
    );

    var compareCents = centsCompare(variant);
    var priceCents = centsFromVariant(variant);
    var showCompare =
      variant &&
      variant.available &&
      compareCents != null &&
      priceCents != null &&
      compareCents > priceCents;

    var formatted = compareCents != null ? formatMoneyCents(compareCents) : "";

    [wrap, stickyWrap].forEach(function (el) {
      if (!el) return;
      if (showCompare) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "");
      }
    });

    [inner, stickyInner].forEach(function (el) {
      if (!el) return;
      el.textContent = showCompare ? formatted : "";
    });
  }

  function getQtyBounds(input) {
    var min = parseInt(input.getAttribute("min"), 10) || 1;
    var maxAttr = input.getAttribute("max");
    var max = Infinity;
    if (maxAttr !== null && maxAttr !== "") {
      var parsed = parseInt(maxAttr, 10);
      if (!isNaN(parsed) && parsed >= min) {
        max = parsed;
      }
    }
    return { min: min, max: max };
  }

  function clampQtyInput(input) {
    if (!input) return 1;
    var bounds = getQtyBounds(input);
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = bounds.min;
    if (v < bounds.min) v = bounds.min;
    if (v > bounds.max) v = bounds.max;
    input.value = v;
    return v;
  }

  function updateQtyButtonStates(wrap) {
    if (!wrap) return;
    var input = wrap.querySelector(".js-qty__num");
    var plus = wrap.querySelector(".js-qty__adjust--plus");
    var minus = wrap.querySelector(".js-qty__adjust--minus");
    if (!input || !plus || !minus) return;

    var bounds = getQtyBounds(input);
    var v = parseInt(input.value, 10) || bounds.min;
    var atMin = v <= bounds.min;
    var atMax = v >= bounds.max;

    minus.disabled = atMin;
    plus.disabled = atMax;
    minus.setAttribute("aria-disabled", atMin ? "true" : "false");
    plus.setAttribute("aria-disabled", atMax ? "true" : "false");
  }

  function syncQtyPair(mainQty, stickyQty) {
    if (!mainQty) return;
    var v = clampQtyInput(mainQty);
    if (stickyQty) {
      if (mainQty.hasAttribute("max")) {
        stickyQty.setAttribute("max", mainQty.getAttribute("max"));
      } else {
        stickyQty.removeAttribute("max");
      }
      stickyQty.value = v;
    }
    var mainWrap = mainQty.closest("[data-trackbar-qty-wrap]");
    var stickyWrap = stickyQty
      ? stickyQty.closest("[data-trackbar-sticky-qty-wrap]")
      : null;
    updateQtyButtonStates(mainWrap);
    updateQtyButtonStates(stickyWrap);
  }

  function initTrackbarQtyWrap(wrap, onAdjusted) {
    if (!wrap) return;
    var input = wrap.querySelector(".js-qty__num");
    var plus = wrap.querySelector(".js-qty__adjust--plus");
    var minus = wrap.querySelector(".js-qty__adjust--minus");
    if (!input || !plus || !minus) return;

    input.readOnly = true;

    plus.addEventListener("click", function () {
      var bounds = getQtyBounds(input);
      var qty = parseInt(input.value, 10) || bounds.min;
      if (qty < bounds.max) {
        input.value = qty + 1;
      }
      if (onAdjusted) onAdjusted();
    });

    minus.addEventListener("click", function () {
      var bounds = getQtyBounds(input);
      var qty = parseInt(input.value, 10) || bounds.min;
      if (qty > bounds.min) {
        input.value = qty - 1;
      }
      if (onAdjusted) onAdjusted();
    });

    updateQtyButtonStates(wrap);
  }

  function updateVariantUi(root, variant, atcTemplate) {
    var str = getStrings(root);
    var mainBtn = root.querySelector("[data-trackbar-atc-main]");
    var stickyBtn = root.querySelector("[data-trackbar-sticky-atc]");
    var mainLabel = root.querySelector("[data-add-to-cart-text]");
    var stickyLabel = root.querySelector("[data-trackbar-sticky-atc-label]");
    var qtyInput = root.querySelector("[data-trackbar-quantity-input]");
    var stickyQtyInput = root.querySelector(
      "[data-trackbar-sticky-quantity-input]",
    );
    var idInput = root.querySelector('input[name="id"]');

    updateCompareUi(root, variant);

    if (idInput && variant) {
      idInput.value = String(variant.id);
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (!variant) {
      if (mainBtn) {
        mainBtn.disabled = true;
      }
      if (stickyBtn) stickyBtn.disabled = true;
      if (mainLabel) mainLabel.textContent = str.unavailable;
      if (stickyLabel) stickyLabel.textContent = str.unavailable;
      return;
    }

    var priceMoney = formatMoneyCents(centsFromVariant(variant));

    var labelText = atcTemplate.split("[price]").join(priceMoney);

    if (variant.available) {
      if (mainBtn) mainBtn.disabled = false;
      if (stickyBtn) stickyBtn.disabled = false;
      if (mainLabel) mainLabel.textContent = labelText;
      if (stickyLabel) stickyLabel.textContent = labelText;
    } else {
      if (mainBtn) mainBtn.disabled = true;
      if (stickyBtn) stickyBtn.disabled = true;
      var outLabel = unavailableLabel(root, str);
      if (mainLabel) mainLabel.textContent = outLabel;
      if (stickyLabel) stickyLabel.textContent = outLabel;
    }

    if (qtyInput) {
      var max = 9999;
      if (
        variant.inventory_management === "shopify" &&
        variant.inventory_policy === "deny"
      ) {
        max = Math.max(0, variant.inventory_quantity || 0);
        qtyInput.max = max > 0 ? max : 1;
      } else {
        qtyInput.removeAttribute("max");
      }
      var q = parseInt(qtyInput.value, 10) || 1;
      if (
        variant.inventory_management === "shopify" &&
        variant.inventory_policy === "deny"
      ) {
        if (max > 0 && q > max) qtyInput.value = max;
        if (max === 0 && variant.available) qtyInput.value = 1;
      }
      if (!variant.available) {
        qtyInput.value = 1;
      }

      syncQtyPair(qtyInput, stickyQtyInput);
    }
  }

  function getCartErrorMessage(error, fallback) {
    if (!error) return fallback;
    if (typeof error === "string") return error;
    if (error.description) return error.description;
    if (error.message) return error.message;
    return fallback;
  }

  function hideCartError(root) {
    var box = root.querySelector("[data-trackbar-cart-error]");
    var text = root.querySelector("[data-trackbar-cart-error-text]");
    if (!box) return;
    box.setAttribute("hidden", "");
    if (text) text.textContent = "";
  }

  function showCartError(root, message) {
    var box = root.querySelector("[data-trackbar-cart-error]");
    var text = root.querySelector("[data-trackbar-cart-error-text]");
    if (!box || !text) return;
    text.textContent = message;
    box.removeAttribute("hidden");
  }

  function initCartErrorUi(root) {
    var productForm = root.querySelector("product-form");
    var dismiss = root.querySelector("[data-trackbar-cart-error-dismiss]");
    var fallback =
      root.dataset.cartErrorDefault ||
      "Unable to add this item to your cart. Please try again.";

    if (!productForm) return;

    function isOurFormEvent(evt) {
      return evt.target === productForm;
    }

    root.addEventListener("product-form:submit:before", function (evt) {
      if (isOurFormEvent(evt)) hideCartError(root);
    });

    root.addEventListener("product-form:submit:success", function (evt) {
      if (isOurFormEvent(evt)) hideCartError(root);
    });

    root.addEventListener("product-form:submit:error", function (evt) {
      if (!isOurFormEvent(evt)) return;
      showCartError(
        root,
        getCartErrorMessage(evt.detail && evt.detail.error, fallback),
      );
    });

    root.addEventListener("variantChange", function () {
      hideCartError(root);
    });

    if (dismiss) {
      dismiss.addEventListener("click", function () {
        hideCartError(root);
      });
    }
  }

  function initTrackbarQtyControls(root) {
    var mainQty = root.querySelector("[data-trackbar-quantity-input]");
    var stickyQty = root.querySelector("[data-trackbar-sticky-quantity-input]");
    var mainWrap = root.querySelector("[data-trackbar-qty-wrap]");
    var stickyWrap = root.querySelector("[data-trackbar-sticky-qty-wrap]");

    function syncFromMain() {
      syncQtyPair(mainQty, stickyQty);
    }

    function syncFromSticky() {
      if (!mainQty || !stickyQty) return;
      mainQty.value = stickyQty.value;
      syncQtyPair(mainQty, stickyQty);
    }

    initTrackbarQtyWrap(mainWrap, syncFromMain);
    initTrackbarQtyWrap(stickyWrap, syncFromSticky);
    syncFromMain();
  }

  function initSection(root) {
    var sectionId = root.dataset.sectionId;
    var variantsEl = root.querySelector("[data-trackbar-variant-json]");
    if (!variantsEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }

    var enableSticky = root.getAttribute("data-enable-sticky-bar") === "true";
    var zoomEnabled = root.getAttribute("data-zoom-enabled") === "true";
    var atcTemplate = root.dataset.atcTemplate || "Add to Cart - [price]";
    var dynamicVariants = root.getAttribute("data-dynamic-variants") === "true";

    var swiperInstance = null;
    var swiperEl = root.querySelector(".main-product-trackbar__swiper");
    if (swiperEl && typeof Swiper !== "undefined") {
      var slides = swiperEl.querySelectorAll(".swiper-slide");
      if (slides.length) {
        swiperInstance = new Swiper(swiperEl, {
          slidesPerView: 1.22,
          spaceBetween: 18,
          slidesOffsetAfter: 18,
          centeredSlides: false,
          pagination: {
            el: root.querySelector(".main-product-trackbar__swiper-pagination"),
            clickable: true,
          },
          watchOverflow: true,
        });
      }
    }

    if (zoomEnabled && typeof theme !== "undefined" && theme.Photoswipe) {
      var desk = root.querySelector("[data-trackbar-zoom-root]");
      var mob = root.querySelector("[data-trackbar-zoom-root-mobile]");
      if (desk && desk.dataset.zoom !== "false") {
        new theme.Photoswipe(desk, sectionId + "-desk");
      }
      if (mob && mob.dataset.zoom !== "false") {
        new theme.Photoswipe(mob, sectionId + "-mob");
      }
    }

    if (typeof theme !== "undefined" && theme.Variants) {
      new theme.Variants({
        container: root,
        variants: variants,
        singleOptionSelector: "[data-variant-input]",
        originalSelectorId: 'input[name="id"]',
        enableHistoryState: true,
        dynamicVariantsEnabled: dynamicVariants,
      });

      root.addEventListener("variantChange", function (evt) {
        updateVariantUi(root, evt.detail.variant, atcTemplate);
        goToMediaSlide(root, swiperInstance, evt.detail.variant);
      });
    }

    initTrackbarQtyControls(root);
    initCartErrorUi(root);

    var idInput = root.querySelector('input[name="id"]');
    var currentId = idInput ? idInput.value : null;
    var initialVariant = variants.find(function (v) {
      return String(v.id) === String(currentId);
    });
    if (initialVariant) {
      updateVariantUi(root, initialVariant, atcTemplate);
      goToMediaSlide(root, swiperInstance, initialVariant);
    }

    if (enableSticky) {
      var anchor = root.querySelector("[data-trackbar-atc-anchor]");
      var sticky = root.querySelector("[data-trackbar-sticky-bar]");
      var stickyBtn = root.querySelector("[data-trackbar-sticky-atc]");
      var mainBtn = root.querySelector("[data-trackbar-atc-main]");
      if (anchor && sticky && stickyBtn && mainBtn) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              sticky.hidden =
                entry.isIntersecting || entry.boundingClientRect.top > 0;
            });
          },
          { threshold: 0, rootMargin: "0px 0px 0px 0px" },
        );
        observer.observe(anchor);
        stickyBtn.addEventListener("click", function () {
          if (!mainBtn.disabled) {
            mainBtn.click();
          }
        });
      }
    }
  }

  function boot() {
    document.querySelectorAll("[data-trackbar-root]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
